'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
const components_display_Heading_Heading = require('../../display/Heading/Heading.cjs.js');
const components_display_Heading_HeadingLevel = require('../../display/Heading/HeadingLevel.cjs.js');
const components_display_Img_Img = require('../../display/Img/Img.cjs.js');
const components_marketing_LogoBar_logoIcons = require('./logoIcons.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const sanitizeClassName = (size) => {
  return `${size}`.replace(/[^a-z0-9]/gi, "-");
};
const Styles = styleEncapsulation.labelStyles("LogoBar", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    justify-content: center;
    justify-items: center;
    grid-gap: 30px;
  `,
  title: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.smallPrint1};
    color: ${theme_Colors.Colors.GrayWarm9};
    justify-self: center;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.paragraph3}
    }
  `,
  logosContainer: react.css`
    ${styleMixins_reset.listReset};
    display: grid;
    justify-content: center;
    grid-auto-flow: column;
    grid-gap: 40px;

    @media screen and (min-width: ${breakpoints.desktop}px) {
      grid-gap: 80px;
    }
  `,
  logoContainer: react.css`
    ${styleMixins_reset.boxSizing};
    align-self: center;
    display: flex;
    justify-self: center;
  `,
  desktopLogoContainer: react.css`
    ${styleMixins_reset.boxSizing};
    display: none;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      display: block;
    }
  `,
  mobileLogoContainer: react.css`
    ${styleMixins_reset.boxSizing};
    display: block;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      display: none;
    }
  `,
  defaultLogo: (size) => [
    {
      "> svg": {
        height: "inherit",
        width: "inherit"
      }
    },
    size && styleEncapsulation.withModifier(sanitizeClassName(`${size}x${size}`), {
      height: size,
      width: size
    })
  ]
});
const DefaultLogo = (props) => {
  return react.jsx("span", { css: Styles.defaultLogo(props.size), className: "logobar-defaultLogo", dangerouslySetInnerHTML: { __html: props.svg } });
};
const DefaultLogoIcons = {
  Asana: {
    mobile: components_marketing_LogoBar_logoIcons.AsanaIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.AsanaIcon
  },
  Dropbox: {
    mobile: components_marketing_LogoBar_logoIcons.DropboxIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.DropboxIcon
  },
  Meta: {
    mobile: components_marketing_LogoBar_logoIcons.MetaIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.MetaIcon
  },
  Shopify: {
    mobile: components_marketing_LogoBar_logoIcons.ShopifyIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.ShopifyIcon
  },
  Slack: {
    mobile: components_marketing_LogoBar_logoIcons.SlackIconMobile,
    desktop: components_marketing_LogoBar_logoIcons.SlackIcon
  }
};
const LogoBar = (_props) => {
  const { title, items, size, className } = _props;
  return react.jsx(
    "div",
    { css: Styles.root, className, "data-zds": true },
    react.jsx(
      components_display_Heading_HeadingLevel.HeadingLevel,
      null,
      react.jsx(
        components_display_Heading_Heading.Heading,
        null,
        react.jsx("div", { css: Styles.title, className: "logobar-title", "data-zds": true }, title)
      )
    ),
    react.jsx("ul", { css: Styles.logosContainer, className: "logobar-logosContainer", "data-zds": true }, items && items.length > 0 ? items.map(({ logoUrl, companyName }, i) => react.jsx(
      "li",
      { css: Styles.logoContainer, key: i + logoUrl, "data-zds": true },
      react.jsx(components_display_Img_Img.Img, { alt: companyName, borderRadius: "none", src: logoUrl, height: size, width: size })
    )) : components_marketing_LogoBar_logoIcons.DefaultCompanies.map((company) => react.jsx(
      React.Fragment,
      { key: company },
      react.jsx(
        "li",
        { css: [Styles.logoContainer, Styles.desktopLogoContainer], "data-zds": true },
        react.jsx(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].desktop, { size }))
      ),
      react.jsx(
        "li",
        { css: [Styles.logoContainer, Styles.mobileLogoContainer], "data-zds": true },
        react.jsx(DefaultLogo, Object.assign({}, DefaultLogoIcons[company].mobile, { size }))
      )
    )))
  );
};

exports.LogoBar = LogoBar;
//# sourceMappingURL=LogoBar.cjs.js.map
